import { FC } from 'react';
import { GridCellProps } from '@progress/kendo-react-grid';
import { Box } from '@mui/material';

const ActivityCustomerCell: FC<React.PropsWithChildren<GridCellProps>> = ({ dataItem }) => {
  return (
    <td className="activity-grid__customer-cell" data-grid-col-index={dataItem.activityId}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <span>{dataItem.customerName}</span>
      </Box>
    </td>
  );
};

export default ActivityCustomerCell;
